/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IncidentCommentsListEntry } from './IncidentCommentsListEntry';
import {
    IncidentCommentsListEntryFromJSON,
    IncidentCommentsListEntryFromJSONTyped,
    IncidentCommentsListEntryToJSON,
} from './IncidentCommentsListEntry';

/**
 * 
 * @export
 * @interface FindAllIncidentComments200Response
 */
export interface FindAllIncidentComments200Response {
    /**
     * 
     * @type {Array<IncidentCommentsListEntry>}
     * @memberof FindAllIncidentComments200Response
     */
    data?: Array<IncidentCommentsListEntry>;
}

/**
 * Check if a given object implements the FindAllIncidentComments200Response interface.
 */
export function instanceOfFindAllIncidentComments200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllIncidentComments200ResponseFromJSON(json: any): FindAllIncidentComments200Response {
    return FindAllIncidentComments200ResponseFromJSONTyped(json, false);
}

export function FindAllIncidentComments200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllIncidentComments200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(IncidentCommentsListEntryFromJSON)),
    };
}

export function FindAllIncidentComments200ResponseToJSON(value?: FindAllIncidentComments200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(IncidentCommentsListEntryToJSON)),
    };
}

